{
  "greeting": "Hallo! Wie kann ich Ihnen heute bei Wein helfen?",
  "thinking": "✨ Denke nach...",
  "thinkingStep": "✨ Den perfekten Tropfen für Sie entkorken…🍷",
  "askAboutWine": "Z.B. 1990er Bordeaux Rot ca. $1500 | Burgunder Dorfwein weiß unter $600",
  "askAboutWineFirst": "Ich möchte kaufen (Region + Farbe + Jahrgang + Budget)",
  "waitingForResponse": "Warte auf Antwort...",
  "dailyLimitReached": "Sie haben das tägliche Beratungslimit erreicht. Bitte kommen Sie nach 00:00 HKT zurück.",
  "chatHistory": "Ihr Chatverlauf",
  "noChatHistory": "Noch kein Chatverlauf",
  "startConversation": "Starten Sie ein Gespräch, um es hier zu sehen",
  "backToChat": "Zurück zum Chat",
  "newChat": "Neuer Chat",
  "history": "Verlauf",
  "search": "Suche",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "Weinberater",
  "chat": "Chat",
  "chatNumber": "Chat {number}",
  "wineRecommended": "{count} Wein empfohlen",
  "winesRecommended": "{count} Weine empfohlen",
  "justNow": "Gerade eben",
  "minuteAgo": "Vor {count} Minute",
  "minutesAgo": "Vor {count} Minuten",
  "hourAgo": "Vor {count} Stunde",
  "hoursAgo": "Vor {count} Stunden",
  "dayAgo": "Vor {count} Tag",
  "daysAgo": "Vor {count} Tagen",
  "noMessagesYet": "Noch keine Nachrichten",
  "perBottle": "Pro Flasche",
  "priceNA": "Preis nicht verfügbar",
  "buyNow": "Jetzt kaufen",
  "moreInformation": "Mehr Informationen",
  "share": {
    "button": "Teilen",
    "title": "Gespräch teilen",
    "description": "Teilen Sie dieses Gespräch mit Ihren Freunden über den folgenden Link:",
    "generating": "Teilen-Link wird generiert...",
    "error": "Teilen-Link konnte nicht generiert werden",
    "copy": "Kopieren",
    "copied": "Kopiert!",
    "note": "Hinweis: Dieser Link läuft in 30 Tagen ab. Wenn jemand diesen Link öffnet, sieht er eine Kopie dieses Gesprächs."
  },
  "checkOutWine": "Schauen Sie sich diesen Wein an: {name} {vintage}",
  "linkCopied": "Link in die Zwischenablage kopiert!",
  "contactWhatsApp": "Kontaktieren Sie uns auf WhatsApp für weitere Optionen",
  "errorLoadingWine": "Entschuldigung, ich konnte die Weindetails nicht laden.",
  "errorOccurred": "Beim Abrufen der Antwort ist ein Fehler aufgetreten.",
  "you": "Sie",
  "welcome": {
    "intro": "Willkommen bei WWX, ich bin Zyra, Ihre KI-Weinberaterin. Sie haben Zugang zu:",
    "features": {
      "globalMarket": "Globaler Feinweinmarkt (UK, FR, HK Verkäufer)",
      "realTimeOffers": "Echtzeit-Bestangebote innerhalb Ihres Budgets",
      "personalized": "Personalisierte Empfehlungen nur für Sie",
      "comparison": "Einfacher Jahrgangs- und Markenvergleich",
      "instantCheckout": "Sofortige Mengen und Versandkasse"
    },
    "question": "Was kann ich Ihnen heute empfehlen?",
    "trendingPrompts": "Beispielanfragen",
    "promptExamples": {
      "title": "So fragen Sie:",
      "good": "✓ Gute Beispiele:",
      "bad": "✗ Vermeiden Sie Anfragen ohne Budget:"
    },
    "prompts": {
      "bordeaux": "Bordeaux Rot ca. $800",
      "champagne": "Winzer-Champagner unter $2000",
      "firstGrowth": "Bestes Angebot First Growth 2010-2019"
    }
  },
  "feedback": {
    "helpful": "Das war hilfreich",
    "notHelpful": "Das war nicht hilfreich",
    "thankYou": "Vielen Dank für Ihr Feedback!",
    "whatDidYouLike": "Was hat Ihnen gefallen?",
    "whatCouldBeImproved": "Was könnte verbessert werden?",
    "category": "Kategorie",
    "selectCategory": "Kategorie auswählen",
    "categories": {
      "accuracy": "Genauigkeit",
      "helpfulness": "Hilfsbereitschaft",
      "responseSpeed": "Antwortgeschwindigkeit",
      "clarity": "Klarheit",
      "other": "Sonstiges"
    },
    "comments": "Kommentare",
    "placeholder": "Erzählen Sie uns mehr über Ihre Erfahrung...",
    "cancel": "Abbrechen",
    "submit": "Feedback absenden",
    "submitting": "Wird gesendet..."
  },
  "auth": {
    "limitReached": "Tageslimit erreicht",
    "signUpToday": "Registrieren Sie sich für mehr Nachrichten",
    "limitMessage": "Sie haben Ihr tägliches Nachrichtenlimit erreicht. Registrieren Sie sich für ein kostenloses Konto, um den Chat fortzusetzen.",
    "benefitsMessage": "Erstellen Sie ein kostenloses Konto, um weiter zu chatten und Ihren Chatverlauf geräteübergreifend zu speichern.",
    "remainingMessages": "Sie haben heute noch {count} Nachrichten übrig",
    "signUp": "Registrieren",
    "login": "Anmelden",
    "loggedInAs": "Angemeldet als {email}",
    "logout": "Abmelden"
  }
}
